export default __webpack_public_path__ + "static/media/Icon awesome-star.0f9c15da.svg";